import { blockDefaults } from './blocks.js';
const alignOptions = [
    { value: 'left', label: 'Left' },
    { value: 'center', label: 'Centre' },
    { value: 'right', label: 'Right' }
];
const imagePositionOptions = [
    { value: 'left', label: 'Image left' },
    { value: 'right', label: 'Image right' }
];
const columnOptions = [
    { value: '2', label: 'Two columns' },
    { value: '3', label: 'Three columns' },
    { value: '4', label: 'Four columns' }
];
const iconOptions = [
    { value: 'anchor', label: 'Anchor' },
    { value: 'food', label: 'Food' },
    { value: 'spark', label: 'Spark' },
    { value: 'leaf', label: 'Leaf' },
    { value: 'wrench', label: 'Wrench' },
    { value: 'heart', label: 'Heart' },
    { value: 'star', label: 'Star' },
    { value: 'none', label: 'None' }
];
const backgroundOptions = [
    { value: 'accent', label: 'Accent colour' },
    { value: 'ink', label: 'Ink' },
    { value: 'paper', label: 'Paper' }
];
const definitions = [
    {
        type: 'header',
        label: 'Header',
        category: 'content',
        defaultProps: blockDefaults.header,
        inspector: [
            { kind: 'text', key: 'brand', label: 'Brand name', required: true, maxLength: 100 },
            {
                kind: 'listOfItems',
                key: 'nav',
                label: 'Navigation links',
                itemFields: [
                    { kind: 'text', key: 'label', label: 'Label', required: true, maxLength: 100 },
                    { kind: 'text', key: 'href', label: 'URL', required: true, maxLength: 2000, placeholder: '#section or https://' }
                ]
            },
            { kind: 'link', key: 'cta', label: 'Call to action' }
        ]
    },
    {
        type: 'hero',
        label: 'Hero',
        category: 'content',
        defaultProps: blockDefaults.hero,
        inspector: [
            { kind: 'text', key: 'eyebrow', label: 'Eyebrow', required: true, maxLength: 80 },
            { kind: 'text', key: 'title', label: 'Title', required: true, maxLength: 140 },
            { kind: 'text', key: 'lead', label: 'Lead text', required: true, maxLength: 500 },
            { kind: 'link', key: 'primaryCta', label: 'Primary button' },
            { kind: 'link', key: 'secondaryCta', label: 'Secondary button' },
            { kind: 'image', key: 'image.assetId', label: 'Image', altKey: 'image.alt' }
        ]
    },
    {
        type: 'text',
        label: 'Text',
        category: 'content',
        defaultProps: blockDefaults.text,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'richtext', key: 'body', label: 'Body' },
            { kind: 'select', key: 'align', label: 'Alignment', options: alignOptions }
        ]
    },
    {
        type: 'imageText',
        label: 'Image & text',
        category: 'media',
        defaultProps: blockDefaults.imageText,
        inspector: [
            { kind: 'image', key: 'image.assetId', label: 'Image', altKey: 'image.alt' },
            { kind: 'select', key: 'imagePosition', label: 'Image position', options: imagePositionOptions },
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'richtext', key: 'body', label: 'Body' },
            { kind: 'link', key: 'cta', label: 'Call to action' }
        ]
    },
    {
        type: 'featureGrid',
        label: 'Feature grid',
        category: 'content',
        defaultProps: blockDefaults.featureGrid,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'richtext', key: 'body', label: 'Body' },
            { kind: 'select', key: 'columns', label: 'Columns', options: columnOptions },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Features',
                itemFields: [
                    { kind: 'select', key: 'icon', label: 'Icon', options: iconOptions },
                    { kind: 'text', key: 'title', label: 'Title', required: true, maxLength: 140 },
                    { kind: 'text', key: 'text', label: 'Text', required: true, maxLength: 500 }
                ]
            }
        ]
    },
    {
        type: 'stats',
        label: 'Numbers & stats',
        category: 'content',
        defaultProps: blockDefaults.stats,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading (optional)', maxLength: 140 },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Stats',
                itemFields: [
                    { kind: 'text', key: 'value', label: 'Number', required: true, maxLength: 40 },
                    { kind: 'text', key: 'label', label: 'Label', required: true, maxLength: 140 }
                ]
            }
        ]
    },
    {
        type: 'steps',
        label: 'Steps',
        category: 'content',
        defaultProps: blockDefaults.steps,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'richtext', key: 'body', label: 'Intro' },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Steps',
                itemFields: [
                    { kind: 'text', key: 'title', label: 'Title', required: true, maxLength: 140 },
                    { kind: 'text', key: 'text', label: 'Text', maxLength: 500 }
                ]
            }
        ]
    },
    {
        type: 'quote',
        label: 'Big quote',
        category: 'content',
        defaultProps: blockDefaults.quote,
        inspector: [
            { kind: 'text', key: 'text', label: 'Quote', required: true, maxLength: 400 },
            { kind: 'text', key: 'author', label: 'Name', maxLength: 120 },
            { kind: 'text', key: 'role', label: 'Role or company', maxLength: 160 }
        ]
    },
    {
        type: 'banner',
        label: 'Announcement bar',
        category: 'content',
        defaultProps: blockDefaults.banner,
        inspector: [
            { kind: 'text', key: 'text', label: 'Message', required: true, maxLength: 240 },
            { kind: 'link', key: 'cta', label: 'Button' }
        ]
    },
    {
        type: 'gallery',
        label: 'Gallery',
        category: 'media',
        defaultProps: blockDefaults.gallery,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'select', key: 'columns', label: 'Columns', options: columnOptions },
            {
                kind: 'listOfItems',
                key: 'images',
                label: 'Images',
                itemFields: [
                    { kind: 'image', key: 'assetId', label: 'Image', altKey: 'alt' }
                ]
            }
        ]
    },
    {
        type: 'pricing',
        label: 'Pricing',
        category: 'content',
        defaultProps: blockDefaults.pricing,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'text', key: 'description', label: 'Description', required: true, maxLength: 500 },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Pricing items',
                itemFields: [
                    { kind: 'text', key: 'name', label: 'Name', required: true, maxLength: 100 },
                    { kind: 'text', key: 'price', label: 'Price', required: true, maxLength: 40 },
                    { kind: 'text', key: 'unit', label: 'Unit', maxLength: 40 },
                    {
                        kind: 'listOfItems',
                        key: 'features',
                        label: 'Features',
                        itemFields: [
                            { kind: 'text', key: '.', label: 'Feature', required: true, maxLength: 200 }
                        ]
                    },
                    { kind: 'boolean', key: 'highlighted', label: 'Highlighted' },
                    { kind: 'link', key: 'cta', label: 'Call to action' }
                ]
            }
        ]
    },
    {
        type: 'testimonials',
        label: 'Testimonials',
        category: 'content',
        defaultProps: blockDefaults.testimonials,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Testimonials',
                itemFields: [
                    { kind: 'text', key: 'quote', label: 'Quote', required: true, maxLength: 500 },
                    { kind: 'text', key: 'name', label: 'Name', required: true, maxLength: 100 },
                    { kind: 'text', key: 'role', label: 'Role', required: true, maxLength: 100 }
                ]
            }
        ]
    },
    {
        type: 'menuList',
        label: 'Menu or price list',
        category: 'content',
        defaultProps: blockDefaults.menuList,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            {
                kind: 'listOfItems',
                key: 'sections',
                label: 'Sections',
                itemFields: [
                    { kind: 'text', key: 'name', label: 'Section name', required: true, maxLength: 100 },
                    {
                        kind: 'listOfItems',
                        key: 'items',
                        label: 'Items',
                        itemFields: [
                            { kind: 'text', key: 'name', label: 'Name', required: true, maxLength: 140 },
                            { kind: 'text', key: 'description', label: 'Description', required: true, maxLength: 300 },
                            { kind: 'text', key: 'price', label: 'Price', required: true, maxLength: 40 }
                        ]
                    }
                ]
            }
        ]
    },
    {
        type: 'openingHours',
        label: 'Opening hours',
        category: 'content',
        defaultProps: blockDefaults.openingHours,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'text', key: 'note', label: 'Note', required: true, maxLength: 500 },
            {
                kind: 'listOfItems',
                key: 'hours',
                label: 'Hours',
                itemFields: [
                    { kind: 'text', key: 'days', label: 'Days', required: true, maxLength: 100 },
                    { kind: 'text', key: 'time', label: 'Time', required: true, maxLength: 100 }
                ]
            }
        ]
    },
    {
        type: 'contact',
        label: 'Contact form',
        category: 'contact',
        defaultProps: blockDefaults.contact,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'text', key: 'body', label: 'Body', required: true, maxLength: 500 },
            { kind: 'text', key: 'buttonLabel', label: 'Button label', required: true, maxLength: 100 }
        ]
    },
    {
        type: 'mapAddress',
        label: 'Map & address',
        category: 'contact',
        defaultProps: blockDefaults.mapAddress,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            { kind: 'text', key: 'address', label: 'Address', required: true, maxLength: 500 },
            { kind: 'text', key: 'mapUrl', label: 'Maps link', required: true, maxLength: 2000 },
            { kind: 'text', key: 'buttonLabel', label: 'Button label', required: true, maxLength: 100 }
        ]
    },
    {
        type: 'faq',
        label: 'FAQ',
        category: 'content',
        defaultProps: blockDefaults.faq,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Questions',
                itemFields: [
                    { kind: 'text', key: 'question', label: 'Question', required: true, maxLength: 300 },
                    { kind: 'text', key: 'answer', label: 'Answer', required: true, maxLength: 1000 }
                ]
            }
        ]
    },
    {
        type: 'cta',
        label: 'Call to action band',
        category: 'content',
        defaultProps: blockDefaults.cta,
        inspector: [
            { kind: 'text', key: 'title', label: 'Title', required: true, maxLength: 140 },
            { kind: 'text', key: 'body', label: 'Body', required: true, maxLength: 500 },
            { kind: 'link', key: 'cta', label: 'Call to action' },
            { kind: 'link', key: 'secondaryCta', label: 'Secondary button' },
            { kind: 'select', key: 'background', label: 'Background', options: backgroundOptions }
        ]
    },
    {
        type: 'socialLinks',
        label: 'Social links',
        category: 'contact',
        defaultProps: blockDefaults.socialLinks,
        inspector: [
            { kind: 'text', key: 'heading', label: 'Heading', required: true, maxLength: 140 },
            {
                kind: 'listOfItems',
                key: 'items',
                label: 'Links',
                itemFields: [
                    { kind: 'text', key: 'label', label: 'Label', required: true, maxLength: 100 },
                    { kind: 'text', key: 'href', label: 'URL', required: true, maxLength: 2000 }
                ]
            }
        ]
    },
    {
        type: 'footer',
        label: 'Footer',
        category: 'layout',
        defaultProps: blockDefaults.footer,
        inspector: [
            { kind: 'text', key: 'brand', label: 'Brand name', required: true, maxLength: 100 },
            { kind: 'text', key: 'tagline', label: 'Tagline', required: true, maxLength: 200 },
            {
                kind: 'listOfItems',
                key: 'links',
                label: 'Links',
                itemFields: [
                    { kind: 'text', key: 'label', label: 'Label', required: true, maxLength: 100 },
                    { kind: 'text', key: 'href', label: 'URL', required: true, maxLength: 2000 }
                ]
            },
            { kind: 'text', key: 'copyright', label: 'Copyright', required: true, maxLength: 200 }
        ]
    },
    {
        type: 'spacer',
        label: 'Spacer',
        category: 'layout',
        defaultProps: blockDefaults.spacer,
        inspector: [
            { kind: 'number', key: 'height', label: 'Height in pixels', min: 0, max: 600, step: 8 },
            { kind: 'boolean', key: 'divider', label: 'Show divider' }
        ]
    },
    {
        type: 'designed',
        label: 'Designed page',
        category: 'layout',
        defaultProps: blockDefaults.designed,
        inspector: []
    }
];
export const blockRegistry = Object.fromEntries(definitions.map((definition) => [definition.type, definition]));
//# sourceMappingURL=inspector.js.map